import { Component } from "react";
import * as React from "react";
import { SectionHeader } from "../components/visual/SectionHeader";

import { ProductSelector } from "../components/product/ProductSelector";

import { ICustomer } from "../api/models/Customer";
import { ALL_PRODUCTS, Product } from "../api/models/Product";
import { CustomerForm } from "../components/form/CustomerForm";

import { Button } from "src/components/controls/Button";

import { DEFAULT_BACKEND_CONNECTOR } from "src/api/BackendConnector";
import { IOrder } from "src/api/models/Order";

import bgWhiteDirt from "../images/bgWhiteDirt.jpg";
import shells1 from "../images/shells1_bw.jpg"

import { EMAIL } from "src/config/Config";
import { primary } from "src/styles/Colors";

interface IOrderViewState {
    error: string;
    errorColor: string;
    products: Array<{
        product: Product,
        amount: number
    }>
    selection: Map<number, number>;
    customer: ICustomer;
    remarks: string;
}

export class OrderView extends Component<any, IOrderViewState> {
    constructor(props: any) {
        super(props);

        this.state = {
            customer: {} as ICustomer,
            error: "",
            errorColor: "red",
            products: ALL_PRODUCTS.filter(p => p.soldOut !== true)
                .map(p => {
                    return {
                        amount: 0,
                        product: p
                    }
                })
            ,
            remarks: null as any,
            selection: new Map(),
        }

        this.state.products.forEach(p => this.state.selection.set(p.product.id, 0));

        this.handleSelect = this.handleSelect.bind(this);
        this.handleCustomerChange = this.handleCustomerChange.bind(this);
        this.handleRemarksChange = this.handleRemarksChange.bind(this);
        this.handleClickBuy = this.handleClickBuy.bind(this);
    }

    public render() {
        const selectors = this.state.products.map((p) => (<ProductSelector key={p.product.id} product={p.product} amount={this.state.selection.get(p.product.id) as number} onChange={this.handleSelect.bind(this, p.product.id)}/>));

        return (
            <div>
                <section style={{ paddingTop: "5rem", paddingBottom: "5rem", backgroundSize: "cover", backgroundPosition: "center", backgroundImage: `url(${shells1})` }}>
                    <SectionHeader title="Bestellen" subtitle="Wir freuen uns, dass Sie sich für unsere Produkte interessieren!" titleColor={primary} subtitleColor="white"/>
                </section>
                <section style={{ backgroundImage: `url(${bgWhiteDirt})` }}>
                    <div className="grid-container" style={{ paddingTop: "2rem", paddingBottom: "2rem" }}>
                        <div className="grid-x grid-margin-x">
                            {selectors}
                        </div>
                        <div className="grid-x">
                            <div className="cell medium-8 medium-offset-2 text-center" style={{ paddingTop: "1rem", paddingBottom: "1rem" }}>
                                <h4 style={{ color: "black" }}>Alle Preise zzgl. 4.90 EUR Porto</h4>
                                <hr/>
                            </div>
                        </div>
                    </div>

                </section>
                <section style={{ backgroundColor: "#121215" }}>
                    <div className="grid-container" style={{ paddingTop: "3rem", paddingBottom: "3rem" }}>
                        <div className="grid-x">
                            <div className="cell medium-8 medium-offset-2">
                                <CustomerForm onChange={this.handleCustomerChange}/>
                            </div>
                            <div className="cell small-8 medium-offset-2">
                                <label style={{ color: "#fefefe", fontSize: "1rem"}}>
                                    Anmerkungen (optional, maximal 500 Zeichen)
                                    <textarea name="" id="fake-remarks" rows={4} maxLength={500} onChange={this.handleRemarksChange}/>
                                </label>
                            </div>
                            <div className="cell medium-offset-2 medium-8">
                                <p style={{ color: this.state.errorColor }}>
                                    { this.state.error }
                                </p>
                            </div>
                            <div className="cell small-3 small-offset-2">
                                <Button background="#FF8800" color="#050505" onClick={this.handleClickBuy}><b style={{ letterSpacing: ".2rem" }}>JETZT KAUFEN</b></Button>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }

    private handleSelect(productId: number, newAmount: number): void {
        if (newAmount >= 0) {
            const selection = new Map(this.state.selection);
            selection.set(productId, newAmount);
            this.setState({ selection });
        }
    }

    private handleRemarksChange(event: React.ChangeEvent<HTMLTextAreaElement>): void {
        if (event.target !== null) {
            this.setState({ remarks: event.target.value });
        }
    }

    private isEmailValid(email: string): boolean {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    private handleClickBuy(): void {
        // TODO: Validate customer form

        if (!this.isEmailValid(this.state.customer.email)) {
            this.setState({ errorColor: "red", error: "Bitte geben Sie eine valide E-Mail-Adresse an!", });
            return;
        }

        // TODO: Validate zip

        // Build order object which will be sent later
        const order: IOrder = { positions: [], customer: this.state.customer };
        this.state.selection.forEach((amount, productId) => {
            if (amount > 0) {
                const product = this.state.products.find(x => x.product.id === productId);
                if (product == null) {
                    throw new Error("Selected product not found!");
                }

                order.positions.push({
                    amount,
                    product: product.product
                })
            }
        })

        order.remarks = this.state.remarks;

        if (order.positions.length !== 0) {
            DEFAULT_BACKEND_CONNECTOR.sendOrder(order)
                .then(response => {
                    if (response.status < 200 || response.status >= 300) {
                        throw new Error("Received unexpected status code " + response.status + "!");
                    } else {
                        this.setState({ error: "Vielen Dank für Ihre Bestellung", errorColor: "green" });
                        // TODO: Display Success Message / Page
                    }
                })
                .catch(err => {
                    this.setState({ errorColor: "red", error: "Es ist ein unerwarteter Fehler aufgetreten. Bitte melden Sie sich bei uns per E-Mail unter " + EMAIL + " Vielen Dank! Wir bitten um Entschuldigung." });
                })
        } else {
            this.setState({ errorColor: "red", error: "Sie müssen wenigstens einen Artikel auswählen!", })
        }
    }

    // tslint:disable-next-line:no-empty
    private handleCustomerChange(newCustomer: ICustomer) {
        this.setState({ customer: newCustomer })
    }
}



// WEBPACK FOOTER //
// ./src/views/OrderView.tsx